module.exports = __webpack_public_path__ + "img/thumbnail-kpb.0b9b5c71.jpg";